<template lang="pug">
el-container.is-vertical(v-loading="!code")
  div.padding.no-bottom
    h2 Airport {{code | uppercase}} Stores
    .text-right
      el-button(@click="createStore") + Create a store
  el-container.is-vertical.padding
    el-container.is-vertical(ref="tableContainer")
      el-table(
        :data="stores"
        :max-height="tableHeight"
        :border="true"
        :default-sort="{prop: 'name', order: 'ascending'}"
        stripe)
        el-table-column(fixed="left" prop="name" label="Name" :sortable="true")
          template(slot-scope="scope")
            router-link(:to="{path: './stores/' + scope.row.id}") {{scope.row.name}}
        el-table-column(prop="type" label="Type" :sortable="true")
          template(slot-scope="scope")
            | {{scope.row.type | formattedType}}
        el-table-column(prop="location" label="Location" :sortable="true")
        el-table-column(fixed="right" label="Operations")
          template(slot-scope="scope")
            el-button(
              @click.native.prevent="editStore(scope.row)"
              size="small") Edit
            el-button(
              @click.native.prevent="deleteStore(scope.row)"
              type="danger"
              size="small") Remove
</template>

<script>
import AirportsService from '@/services/AirportsService';

export default {
  filters: {
    formattedType(types) {
      const capitalize = str => str.charAt(0).toUpperCase() + str.substr(1);
      return types
        .map(type => {
          const fixedType = type
            .split('-')
            .map(txt => capitalize(txt))
            .join('-');
          return capitalize(fixedType);
        })
        .join(' / ');
    },
    uppercase(text) {
      return text.toUpperCase();
    },
  },
  props: {
    id: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      code: '',
      stores: [],
      tableHeight: 250,
    };
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
      vm.tableHeight = vm.$refs.tableContainer.$el.clientHeight;
    }, 10);
    window.onresize = () => {
      vm.tableHeight = vm.$refs.tableContainer.$el.clientHeight;
    };
  },
  methods: {
    fetchData() {
      AirportsService.getAirportCode(this.id)
        .then(({ data }) => {
          this.code = data.code;
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: error.response
              ? error.response.data.errorMessage
              : error.message,
          });
        });
      AirportsService.getAirportStores(this.id)
        .then(({ data }) => {
          this.stores = data.concat();
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: error.response
              ? error.response.data.errorMessage
              : error.message,
          });
          this.$router.push('/');
        });
    },
    createStore() {
      this.$router.push({ name: 'NewAdminAirportStore' });
    },
    editStore(store) {
      this.$router.push(`/airports/${this.id}/stores/${store.id}`);
    },
    deleteStore(store) {
      this.$confirm('Are you sure you want to delete this store?', 'Warning', {
        type: 'warning',
        confirmButtonText: 'Yes, Delete!',
      })
        .then(() => {
          AirportsService.deleteAirportStore(this.id, store.id)
            .then(() => {
              this.fetchData();
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message:
                  error.response.data.errorMessage || error.response.data,
              });
            });
        })
        .catch(err => {
          this.$message({
            type: 'info',
            message: err,
          });
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.clearfix
  overflow auto

  &::after
    content ''
    clear both
    display table

.title-row
  line-height 0

.pull-left
  float left

.pull-right
  float right

.padding
  padding 20px

  &.no-bottom
    padding-bottom 0
</style>




// WEBPACK FOOTER //
// src/components/AdminAirportStores.vue